import { render, staticRenderFns } from "./source-list.vue?vue&type=template&id=f9632ac8&scoped=true&"
import script from "./source-list.vue?vue&type=script&lang=ts&"
export * from "./source-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9632ac8",
  null
  
)

export default component.exports